<template>
    <Button
        severity="secondary"
        class="p-button-extra-sm"
        icon="pi pi-question-circle"
        @click="onShowTour"
        text
        :title="$t('lang.cluster.tour_title')"
    />
</template>

<script>
import Button from "primevue/button";
export default {
    name: "ShowTourButton",
    props: {
        tourId: {
            type: String,
            required: true,
        }
    },
    methods: {
        onShowTour() {
            this.$emitter.emit(this.tourId);
        }
    },
    components: {
        Button,
    }
}
</script>
